import { SET_LOCALE } from "../constants/action-types";

const initialState = {
  mainLang: "ko",
};

const languageReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_LOCALE:
      return {
        ...state,
        mainLang: action.payload,
      };
    default:
      return state;
  }
};

export default languageReducer;
